/**
 * ProtectedPage.js
 * Author: Markus.van.Kempen@gmail.com
 * Date: 2nd Nov 2025
 */

import React from 'react';
import { useVisibility } from '../context/VisibilityContext';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import LoadingSpinner from './LoadingSpinner';

const ProtectedPage = ({ pageKey, children, fallback = null }) => {
  const { isPageVisible, getPageMaintenanceMessage, getPageRedirectUrl, loading } = useVisibility();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading) {
      const redirectUrl = getPageRedirectUrl(pageKey);
      if (redirectUrl) {
        window.location.href = redirectUrl;
        return;
      }
    }
  }, [loading, pageKey, getPageRedirectUrl]);

  if (loading) {
    return (
      <div className="page-loading">
        <LoadingSpinner message="Loading page..." />
      </div>
    );
  }

  const pageVisible = isPageVisible(pageKey);

  if (!pageVisible) {
    if (fallback) {
      return fallback;
    }

    return (
      <div className="page-maintenance">
        <div className="maintenance-content">
          <h2>Page Unavailable</h2>
          <p>{getPageMaintenanceMessage(pageKey)}</p>
          <button 
            onClick={() => navigate('/')}
            className="btn btn-primary"
          >
            Return to Home
          </button>
        </div>
      </div>
    );
  }

  return children;
};

export default ProtectedPage;
